import { AbgSxProps } from '@abg/typings';

export const warningTextStyling: WarningTextStylingType = {
  warningTextWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '400',
  },
  warningIcon: {
    fontSize: '16px',
  },
};

export type WarningTextStylingType = {
  warningTextWrapper: AbgSxProps;
  warningIcon: AbgSxProps;
};
